import messagesEnglish from '@/libs/i18n/sections/en/chatbot_fake.js'

const translateResponseBody = (message, typeMessage, lang) => {
  let finalMessage = message.body
  if (lang === "en") {
    const messagesEng = messagesEnglish.chatbot_fake
    finalMessage = messagesEng[typeMessage]
    return finalMessage
  }
  return finalMessage
}

const translateResponseOptions = (message, lang) => {
  let finalMessage = message.options
  if (lang === "en") {
    const messagesEng = messagesEnglish.chatbot_fake
    finalMessage.options.forEach(option => {
      option.name = messagesEng[option.code]
      if (option.options) {
        const keys = Object.keys(option.options).forEach(opt => {
          option.options[opt] = messagesEng[opt]
        });
      }
    });
    return finalMessage
  }
  return finalMessage
}

export default {
  namespaced: true,
  state: {
    isFirtsTime: true,
    isFirstMessage: true,
    promtToSend: {
      isComplete:false,
    },
    responses: {
      welcome: {
        body: 'Hola, soy Omniview AI, ¿En qué puedo ayudarte?, puedo sugerirte las siguientes opciones:',
        completed: false,
        from: 'bot',
        type: 'text',
        options: {
          message: '',
          options: [
            { name: 'Crear chart tipo bar ', code: 'bar' },
            { name: 'Crear chart tipo dona ', code: 'pie'},
            { name: 'Crear lista ', code: 'list'},
          ]
        }
      },
      success: {
        body: 'Aqui tienes el resultado:',
        completed: false,
        from: 'bot',
        type: 'card',
        value: {
          id: 1445555,
          chart_id: 34555555,
          data: {},
          name: "Status Alarms",
          chart: "pie",
          field: "status",
          model: "Alarm",
          filters: {},
          keep_filters: [],
          date_field: null
        }
      },
      typeEvent: {
        body: 'Selecciona el tipo de evento que quiere consultar',
        completed: false,
        from: 'bot',
        type: 'text',
        options: {
          message: '',
          options: [
            { name: 'Alarmas', code: 'Alarm' },
            { name: 'Camera', code: 'Camera'},
            { name: 'Detection Events', code: 'DetectionEvent'},
          ]
        }
      },
      groupAlarm : {
        body: 'Selecciona tipo de agrupamiento',
        completed: false,
        from: 'bot',
        type: 'text',
        options: {
          message: '',
          options: [
            { name: 'Status', code: 'status' },
            { name: 'Tipo de alarma', code: 'type'},
            { name: 'Tenant', code: 'id_tenant'},
          ]
        }
      },
      groupDetectionEvent: {
        body: 'Selecciona tipo de agrupamiento',
        completed: false,
        from: 'bot',
        type: 'text',
        options: {
          message: '',
          options: [
            { name: 'Tipo de Evento', code: 'event_type'},
          ]
        }
      },
      groupCamera: {
        body: 'Selecciona tipo de agrupamiento',
        completed: false,
        from: 'bot',
        type: 'text',
        options: {
          message: '',
          options: [
            { name: 'Status', code: 'online' },
            { name: 'Centro', code: 'id_center'},
            { name: 'Sector', code: 'id_sector'},
            { name: 'Tenant', code: 'id_tenant'},
          ]
        }
      },
      filters: {
        body: 'Te puedo sugerir los siguientes filtros',
        completed: false,
        from: 'bot',
        type: 'text',
        options: {
          hasFilters: true,
          message: '',
          options: []
        }
      },
      metadata: {
        body: 'Te puedo sugerir los siguientes filtros por metadata',
        completed: false,
        from: 'bot',
        type: 'text',
        options: {
          hasFilters: true,
          message: '',
          options: [
            { name: 'Objeto', code: 'car', options: {
              car: 'Auto',
              person: 'Persona',
            }}
          ]
        }
      },
      metadataOption: {
        body: '¿Qué filtros te gustaría aplicar?, Te puedo sugerir un ejemplo: muestrame los autos color rojo, que contenga placas GCG',
        completed: false,
        from: 'bot',
        type: 'text',
        options: {
          hasFilters: true,
          message: '',
          options: []
        }
      },
    },
    steps: {
      1: {
        code: 'typeChart',
        value: ''
      },
      2: {
        code: 'typeEvent',
        value: ''
      },
      3: {
        code: 'groups',
        value: ''
      },
      4: {
        code: 'filters',
        value: {}
      },
      5: {
        code: 'metadata',
        value: {}
      }
    },
    currentStep: 0,
    chat: [],
    viewHasSidebar: false,
    isOpenLuxriotSidebar: false
  },
  getters: {
    getIsOpenLuxriotSidebar(state) {
      return state.isOpenLuxriotSidebar
    },
    getViewHasSidebar(state) {
      return state.viewHasSidebar
    },
    getCurrentEventType(state) {
      return state.steps['2'].value
    },
    getStepsResume(state) {
      return state.steps
    },
    getCurrentStep(state) {
      return state.currentStep
    },
    getDefaultResponses(state) {
      return state.responses
    },
    getIsFirstMessage(state) {
      return state.isFirstMessage
    },
    getChat(state) {
      return state.chat
    },
  },
  mutations: {
    setIsOpenLuxriotSidebar(state, status) {
      state.isOpenLuxriotSidebar = status
    },
    setViewHasSidebar(state, status) {
      state.viewHasSidebar = status
    },
    setAllMessagesCompleted(state, filters) {
      state.chat.forEach(message => {
        if (!message.completed) message.completed = true
      });
    },
    setFilters(state, filters) {
      state.responses.filters.options.options = filters
    },
    reloadChat(state) {
      state.chat = []
      state.isFirstMessage = true
      state.currentStep = 0
    },
    updateStep(state, data) {
      state.steps[`${data.index}`].value = data.value
    },
    updateCurrentStep(state, step) {
      state.currentStep = step
    },
    addMessage(state, data) {
      if (data.message.from === "bot") {
        const lang = this.getters["user/getPreferences"].lang;
        data.message.body = translateResponseBody(data.message, data.typeMessage, lang)
        if (data.message.options?.options && data.typeMessage !== "sugestion_filters") {
          data.message.options = translateResponseOptions(data.message, lang)
        }
      }

      state.chat.push(data.message)
    },
    setIsFirstMessage(state, status) {
      state.isFirstMessage = status
    },
  },
  actions: {
  },
}
